import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs';
import { API_HOST } from 'environments/environment';
import { APIResponse } from 'fakturnia-shared';
import { AuthService } from 'shared/services/auth.service';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  selector: 'app-google-callback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './google-callback.component.html'
})
export class GoogleCallbackComponent implements OnInit {

  isLoading = true;
  success = false;
  error: string | null = null;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _http: HttpClient,
    private _authService: AuthService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit() {
    const code = this._route.snapshot.queryParamMap.get('code');
    const state = this._route.snapshot.queryParamMap.get('state');
    const errorParam = this._route.snapshot.queryParamMap.get('error');

    if (errorParam) {
      this.isLoading = false;
      this.error = 'Logowanie przez Google zostało anulowane.';
      return;
    }

    if (!code) {
      this.isLoading = false;
      this.error = 'Brak kodu autoryzacji z Google.';
      return;
    }

    this._http.post<APIResponse>(API_HOST + 'auth/google/callback', { code, state })
      .pipe(take(1))
      .subscribe({
        next: (response: APIResponse) => {
          if (!response.success) {
            this.isLoading = false;
            this.error = response.message || 'Nie udało się zalogować przez Google.';
            return;
          }

          // Logowanie zakończone sukcesem - zapisz tokeny i przekieruj
          this._completeGoogleLogin(response.data);
        },
        error: (err) => {
          this.isLoading = false;
          this.error = 'Wystąpił błąd podczas logowania przez Google.';
          console.error('Google login error:', err);
        }
      });
  }

  private _completeGoogleLogin(data: any) {
    // Konto z włączonym 2FA: nie pokazuj animacji sukcesu — backend nie wydał jeszcze
    // sesji, tylko zwrócił tymczasowy token. Od razu pokaż dialog weryfikacji 2FA.
    if (data?.requiresTwoFactor) {
      this.isLoading = false;
      this._authService.completeSocialLogin(data, true);
      return;
    }

    // Pokaż sukces i poczekaj 2 sekundy przed przekierowaniem
    this.success = true;

    setTimeout(() => {
      this._authService.completeSocialLogin(data, true);
    }, 2000);
  }

  goToLogin() {
    this._router.navigate(['/logowanie']);
  }
}
